import { CardView, CreateCardBody } from '@lemoncloud/lemon-payments-api';
import { Params } from '@lemoncloud/lemon-web-core';

import { ListResult } from '@codes/base-api';
import { webCore } from '@codes/web-core';

import { BulkCardUpdateBody } from '../types';

const PAYMENT_ENDPOINT = import.meta.env.VITE_PAYMENT_ENDPOINT;

export const fetchCards = async (params: Params): Promise<ListResult<CardView>> => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'GET',
            baseURL: `${PAYMENT_ENDPOINT}/cards/0/list`,
        })
        .setParams({ ...params })
        .execute<ListResult<CardView>>();

    return { ...data };
};

export const createCard = async (cardBody: CreateCardBody): Promise<CardView> => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'POST',
            baseURL: `${PAYMENT_ENDPOINT}/cards/0/enroll`,
        })
        .setBody({ ...cardBody })
        .execute<CardView>();

    return data;
};

export const bulkUpdateCards = async (cardsBody: BulkCardUpdateBody): Promise<CardView[]> => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'PUT',
            baseURL: `${PAYMENT_ENDPOINT}/cards/0/bulk`,
        })
        .setBody({ ...cardsBody })
        .execute<ListResult<CardView>>();

    return data.list;
};

export const deleteCard = async (cardId: string): Promise<CardView> => {
    if (!cardId) {
        throw new Error('deleteCard: @cardId is required');
    }

    const { data } = await webCore
        .buildSignedRequest({
            method: 'DELETE',
            baseURL: `${PAYMENT_ENDPOINT}/cards/${cardId}`,
        })
        .setParams({ cascade: true })
        .setBody({})
        .execute<CardView>();

    return data;
};
